/** Codes auth qui justifient une déconnexion forcée (pas les erreurs réseau). */
export const HARD_AUTH_LOGOUT_CODES = new Set([
  'NO_REFRESH_TOKEN',
  'REFRESH_TOKEN_INVALID',
  'USER_INACTIVE',
  'ACCOUNT_DISABLED',
  'ACCOUNT_REVOKED',
  'INVALID_TOKEN',
]);

export function getAuthErrorCode(error) {
  const payload = error?.response?.data;
  const nested = payload?.error;
  if (nested && typeof nested === 'object' && nested.code != null) {
    return String(nested.code);
  }
  if (payload?.code != null) return String(payload.code);
  return null;
}

/**
 * true uniquement pour une réponse HTTP avec code auth « dur ».
 * Réseau / timeout / 5xx / 401 métier sans code → false.
 */
export function isHardAuthLogoutError(error) {
  if (!error?.response) return false;
  const code = getAuthErrorCode(error);
  return Boolean(code && HARD_AUTH_LOGOUT_CODES.has(code));
}

/**
 * Échec de POST /auth/refresh justifiant un logout.
 * Codes durs, ou 401 (session absente / invalide).
 */
export function isHardRefreshFailure(error) {
  if (isHardAuthLogoutError(error)) return true;
  if (!error?.response) return false;
  return Number(error.response.status || 0) === 401;
}

export function isTransientRefreshFailure(error) {
  if (!error?.response) return true;
  const status = Number(error.response.status || 0);
  if (status >= 500 || status === 429) return true;
  const code = String(error?.code || '').toUpperCase();
  if (code === 'ECONNABORTED') return true;
  const msg = String(error?.message || '').toLowerCase();
  return msg.includes('timeout');
}
